"use client";

import { Component, ReactNode } from "react";

type ErrorBoundaryProps = {
  children: ReactNode;
  /** Render khi children lỗi — mặc định không hiện gì (ẩn hẳn phần tử lỗi thay vì crash cả trang). */
  fallback?: ReactNode;
};

type ErrorBoundaryState = { hasError: boolean };

/**
 * Chặn lỗi render của 1 nhánh cây con (vd 1 card trong danh sách bị data lỗi) để KHÔNG lan lên làm
 * crash cả trang — bọc quanh từng item của 1 danh sách thì 1 item lỗi chỉ biến mất, các item còn lại
 * vẫn hiển thị bình thường. Bắt buộc dùng class component — React chưa có hook tương đương cho
 * error boundary (`componentDidCatch`/`getDerivedStateFromError`).
 */
class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  state: ErrorBoundaryState = { hasError: false };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error: unknown, info: unknown) {
    // eslint-disable-next-line no-console
    console.error("[ErrorBoundary] Ẩn phần tử lỗi thay vì crash cả trang:", error, info);
  }

  render() {
    if (this.state.hasError) return this.props.fallback ?? null;
    return this.props.children;
  }
}

export default ErrorBoundary;
